import { render } from "./saidas.vue?vue&type=template&id=8097b380&scoped=true"
import script from "./saidas.vue?vue&type=script&lang=js"
export * from "./saidas.vue?vue&type=script&lang=js"

import "./saidas.vue?vue&type=style&index=0&id=8097b380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8097b380"]])

export default __exports__